import React, { useMemo } from 'react';

import AppStoreBlackIcon from '../../../assets/img/icons/mobileStores/AppStoreBlackIcon.svg';
import GooglePlayIconBlack from '../../../assets/img/icons/mobileStores/GooglePlayIconBlack.svg';
import { BaseButton, btnTypes } from '../../../components/buttons/baseButton';

import { storeData } from './data';

import { BtnWrapper, StoreContent, StoreIcon, StoreText } from './styled';

export enum EStoreName {
    AppStore = 'AppStore',
    GooglePlay = 'GooglePlay',
    AppGallery = 'AppGallery',
    MovixAppStore = 'MovixAppStore',
    MovixGooglePlay = 'MovixGooglePlay',
    SmartAppStore = 'SmartAppStore',
    SmartGooglePlay = 'SmartGooglePlay',
    RuStore = 'RuStore',
}

interface IComponentProps {
    store: EStoreName,
    btnType?: 'PRIMARY' | 'OUTLINE',
    simpleMode?: boolean,
    link?: string,
    width?: string | number,
    height?: string | number,
    [key: string]: unknown,
}

const MobileStoreButton = ({
    store,
    btnType = 'PRIMARY',
    simpleMode = false,
    link,
    width,
    height,
    ...rest
}: IComponentProps): JSX.Element => {
    const currentData = storeData[store];

    const imgSrc = useMemo(() => {
        if (simpleMode) {
            return null;
        }

        const imgSrcAppStore = btnType === 'OUTLINE' && currentData.storeType === 'AppStore';
        const imgSrcGooglePlay = btnType === 'OUTLINE' && currentData.storeType === 'GooglePlay';

        if (imgSrcAppStore) {
            return AppStoreBlackIcon;
        }

        if (imgSrcGooglePlay) {
            return GooglePlayIconBlack;
        }

        return currentData.store.icon;
    }, [btnType, currentData.storeType]);

    return (
        simpleMode
            ? <BaseButton
                type={btnTypes.SECONDARY}
                href={link ? link : currentData.link}>
                    {currentData.storeType === 'AppStore'
                        ? 'Скачать для iOS'
                        : 'Скачать для Android'
                    }
            </BaseButton>
            : <BtnWrapper
                href={link ? link : currentData.link}
                btnType={btnType}
                {...rest}
            >
                <StoreContent
                    width={width}
                    height={height}
                >
                    <StoreIcon
                        storeIcon={currentData.storeType}
                        btnType={btnType}
                    >
                        <img src={imgSrc} alt='Изображение для скачивания мобильного приложения' />
                    </StoreIcon>
                    <StoreText
                        btnType={btnType}
                        storeIcon={currentData.storeType}
                        textPath={currentData.store.text}
                    />
                </StoreContent>
            </BtnWrapper>
    );
};

export default MobileStoreButton;
